import React, { useEffect, useState } from "react";
import { QuestionListItem } from "../../../../../service/answerStore";
import { InputNumber } from "antd";
import lodash from "lodash-es";
import styles from "./index.module.scss";

interface Props {
    data: QuestionListItem[];
    onChange: (items: QuestionListItem[]) => void;
}

const defaultNumber: number = 5;

const Index = ({ data, onChange }: Props) => {
    const [group, setGroup] = useState<Record<string, QuestionListItem[]>>();

    function streamPipe(goto: string, water: QuestionListItem[], scope: any) {
        return water
            .filter(item => item?.queTypeDescription === goto)
            .map(item => {
                return { ...item, scope };
            });
    }

    useEffect(() => {
        const Group = lodash.groupBy(data, "queTypeDescription");
        const Pool: Record<string, QuestionListItem[]> = {};
        for (let groupKey in Group) {
            Pool[groupKey] = streamPipe(
                groupKey,
                Group[groupKey],
                defaultNumber
            );
        }
        setGroup(Pool);
    }, [data]);

    function onInput(value: number | undefined, key: string) {
        setGroup(g => {
            if (g) {
                return {
                    ...g,
                    [key]: streamPipe(key, g[key], value)
                };
            }
        });
    }

    useEffect(() => {
        if (group) {
            const values = Object.values(group).flat();
            onChange(values);
        }
    }, [group]);

    if (!group) {
        return null;
    }
    return (
        <div className={styles.root}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>题型</th>
                        <th>选择数量</th>
                        <th>设置分值</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(group).map(key => (
                        <tr key={key}>
                            <td>{key}</td>
                            <td>{group[key].length}</td>
                            <td>
                                <InputNumber
                                    min={0.5}
                                    max={100}
                                    precision={1}
                                    defaultValue={defaultNumber}
                                    style={{ width: "100%" }}
                                    onChange={value => onInput(value, key)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Index;
